import Karaoke from "../components/karaoke/Karaoke";

function KaraokePage() {
  return <Karaoke />;
}

export default KaraokePage;
